
import { createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IPlannedPortfoliosState } from './../../state/planned-portfolios.state';
import { IAppState } from './../../state/app.state';

export const getPlannedPortfoliosState = createFeatureSelector<IAppState, IPlannedPortfoliosState>('plannedPortfolios');

export const getSelectedPlannedIds = createSelector(
  getPlannedPortfoliosState,
  (state) => {
    return state.ids;
  }
);
export const selectSelectedSubscriptionId = createSelector(
  getPlannedPortfoliosState,
  (state) => {
    return state.selectedSubscriptionId;
  }
);
export const plannedPortfolioAdapter = createEntityAdapter<IPlannedPortfolio>({
  selectId: (plannedPortfolio: IPlannedPortfolio) => plannedPortfolio.subscriptionId
});
export const {
  selectAll: selectAllPlannedPortfolios,
  selectEntities: selectPlannedPortfolios
} = plannedPortfolioAdapter.getSelectors(getPlannedPortfoliosState);
export const getSelectedPlannedPortfolio = createSelector(
  selectPlannedPortfolios,
  selectSelectedSubscriptionId,
  (plannedPortfolioEntities, subscriptionId) => plannedPortfolioEntities[subscriptionId]
);
